import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyDtqXa2rHjxwcOGUrkUltam_PAT6CsI2hk",
    authDomain: "withinreach-7aef9.firebaseapp.com",
    projectId: "withinreach-7aef9",
    storageBucket: "withinreach-7aef9.appspot.com",
    messagingSenderId: "435610990342",
    appId: "1:435610990342:web:6bbc0988051f5820861087",
};
const app = initializeApp(firebaseConfig);

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
